import { IResponsibleRoleQuery } from '../interfaces/responsible-role.query.interface';

export class ResponsibleRole {
    roleLabel: string;

    constructor(query: IResponsibleRoleQuery) {
        this.roleLabel = query.role_label;
    }
}
